import React from 'react';

type FillColor = string;
type ClassName = string;

interface Props {
  fillColor: FillColor;
  className: ClassName;
}

const defaultProps = {
  className: '',
  fillColor: '#53585E',
};

const WalletIcon = ({
  fillColor,
  className,
}: Props): React.ReactElement<React.ReactNode> => (
  <svg
    viewBox="0 0 54 42"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g fill="none" fillRule="evenodd">
      <g transform="translate(-490 -281)" fill={fillColor}>
        <g transform="translate(490 281)">
          <g>
            <path d="M39.08925,27.42425 C37.1714063,27.42425 35.6121563,25.8055 35.6121563,23.818375 L35.6121563,18.18425 C35.6121563,16.195375 37.1714063,14.576625 39.08925,14.576625 L52.2610313,14.576625 C52.4078438,14.576625 52.5462188,14.60375 52.6879688,14.623 L52.6879688,5.83275 C52.6879688,2.8595 50.3415,0.4235 47.4719063,0.4235 L5.2160625,0.4235 C2.3473125,0.4235 0,2.8595 0,5.83275 L0,36.1655 C0,39.1405 2.3473125,41.5765 5.2160625,41.5765 L47.47275,41.5765 C50.3415,41.5765 52.6888125,39.141375 52.6888125,36.1655 L52.6888125,27.379625 C52.5470625,27.397125 52.4086875,27.42425 52.261875,27.42425 L39.08925,27.42425 Z" />
            <path
              d="M52.2610313,16.380875 L39.08925,16.380875 C38.1332813,16.380875 37.3502813,17.189375 37.3502813,18.18425 L37.3502813,23.818375 C37.3502813,24.80975 38.1332813,25.62175 39.08925,25.62175 L52.2610313,25.62175 C53.217,25.62175 54,24.80975 54,23.818375 L54,18.18425 C54,17.189375 53.217,16.380875 52.2610313,16.380875 Z M42.8085,23.75975 C41.340375,23.75975 40.149,22.5225 40.149,21 C40.149,19.4775 41.340375,18.242 42.8085,18.242 C44.2783125,18.242 45.468,19.4775 45.468,21 C45.468,22.5225 44.2791563,23.75975 42.8085,23.75975 Z"
              fillRule="nonzero"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

WalletIcon.defaultProps = defaultProps;

export { WalletIcon };
